import {BootstrapLicenseService} from '@core/services/bootstrap/bootstrap-license.service';

export function BootstrapLicenseFactory(bootstrap: BootstrapLicenseService) {
  return (): Promise<void> => bootstrap.getBootstrapLicense();
}
